import { useEffect } from "react";
import {
  AppVariation,
  type ClientConfig,
} from "src/client-config/getClientConfig.ts";
import b2bgateLogoSrc from "src/assets/b2b-gate-favicon.ico";

export const useAppMeta = ({ config }: { config: ClientConfig }) => {
  useEffect(() => {
    if (
      config.appVariation === AppVariation.B2bGate ||
      config.appVariation === AppVariation.B2bGateDemo ||
      config.appVariation === AppVariation.B2bGateSupplier
    ) {
      const title = document.head.querySelector("title");
      if (title) {
        title.textContent = "B2B Gate";
      }
      const favicon = document.head.querySelector("link[rel='icon']");
      if (favicon) {
        favicon.setAttribute("href", b2bgateLogoSrc);
      }
    }
  }, [config]);
};
